import { connectBaseApi, scaleClient, createRpcQuery, ConnectProto } from "@racoon/api";

const scaleGrpc = connectBaseApi
  .enhanceEndpoints({ addTagTypes: ["ScaleRecord"] })
  .injectEndpoints({
    endpoints: (build) => ({
      scaleRecordList: createRpcQuery(build, scaleClient, "scaleRecordList", {
        providesTags: ["ScaleRecord"],
      }),
    }),
    overrideExisting: false,
  });

export const { useScaleRecordListQuery } = scaleGrpc;

export type ScaleRecord = ConnectProto.ScaleRecord;
export type ScaleRecordListRequest = ConnectProto.ScaleRecordListRequest;
